import { render, staticRenderFns } from "./ModalDepositMoneyError.vue?vue&type=template&id=52e0e4e3&scoped=true&"
import script from "./ModalDepositMoneyError.vue?vue&type=script&lang=js&"
export * from "./ModalDepositMoneyError.vue?vue&type=script&lang=js&"
import style0 from "./ModalDepositMoneyError.vue?vue&type=style&index=0&id=52e0e4e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e0e4e3",
  null
  
)

export default component.exports